import type { FC } from 'react';
import { useId } from 'react';
import { Tooltip } from 'react-tooltip';
import * as Styled from './styled';
import type { LabelProps } from './types';

export * from './types';

export const Label: FC<LabelProps> = (props) => {
  const { theme, bgColor, textColor, size, onClick, content, tooltip } = props;
  const id = useId();

  return (
    <>
      {!!tooltip && <Tooltip id={id} />}

      <Styled.Container
        labelTheme={theme}
        bgColor={bgColor}
        textColor={textColor}
        size={size}
        onClick={onClick}
        clickable={(!!onClick).toString()}
        {...(tooltip ? { 'data-tooltip-content': tooltip, 'data-tooltip-id': id } : {})}
      >
        {content}
      </Styled.Container>
    </>
  );
};
